import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="noise-overlay" aria-hidden="true" />
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md border border-white/10 bg-surface p-10 lg:p-14 text-center"
      >
        <XCircle className="w-14 h-14 text-[#8A8A8A] mx-auto mb-6" />
        <h1 className="font-serif text-4xl mb-4">Payment cancelled</h1>
        <p className="text-[#8A8A8A] font-light mb-8">
          No charge was made. You can pay anytime, or call us at (516) 262-2059.
        </p>
        <a href="/" data-testid="cancel-back-btn"
          className="inline-flex items-center gap-2 bg-gold text-black px-6 py-3 hover:bg-gold-hover transition-colors duration-400">
          <ArrowLeft className="w-4 h-4" /><span className="overline text-black">Back to site</span>
        </a>
      </motion.div>
    </div>
  );
}
